export default "__VITE_ASSET__D9Qr2iaf__"